import { PageHero, CtaBlock } from "@/components/site/Ui";
import ProjectRows from "@/components/site/Projects";
import { useSeo } from "@/lib/seo";

export default function Realisations() {
  useSeo({
    title: "Réalisations — sites de commerces à Toulouse",
    description: "Maison Sanaa, Oh la Vache !, L'étoile d'Oran : trois sites conçus par SANAA DESIGN STUDIO pour des commerces toulousains.",
    path: "/realisations",
  });
  return (
    <>
      <PageHero testid="realisations-hero" label="Réalisations" lines={["Projets choisis."]}
        intro="Pour chaque projet : l'enjeu, ce que j'ai livré, la palette." />
      <section className="wrap pb-20" data-testid="realisations-list"><ProjectRows /></section>
      <CtaBlock />
    </>
  );
}
